import $fetch from "../$fetch"
import Filter from "../filter/Filter"
import app from "app.controller"
import productStore from "stores/productStore"

const REACT_APP_API_VERSION = process.env.REACT_APP_API_VERSION || ""
const baseSearchUrl = `data/${REACT_APP_API_VERSION}`

var sort_options = {
  article_nr      : true,
  "price&dir=desc": true,
  "price&dir=asc" : true,
  created         : true,
  des             : true,
  sort            : true,
  price           : true,
  topseller       : true
}

export default class Products {
  constructor( shop, config ) {
    this.config = config
    this.shop = shop
    this.filters = {}
    this.filters.category = new Filter().category( true )
  }

  search( value, { filter, sort, count, start, page = 1 } = {} ) {
    // console.log("search::", value, {filter, sort, count, page})
    count = count || this.shop.config.pageSize
    start = start || (page - 1) * count
    return this.query( {
      value,
      filter,
      sort,
      count,
      start
    } )
  }

  listPost( product_ids ) {
    if ( !Array.isArray( product_ids ) ) throw("list() expects an Array as its' sole argument")
    // /shop/rest/data/productlist?list=[100003,100004]
    let url = this.config.API + `${baseSearchUrl}/productlist?` + app.getQueryLanguageParameter( "" )
    return $fetch( url, {
      mode       : 'cors',
      credentials: "include",
      method     : "POST",
      body       : JSON.stringify( { list: product_ids } )
    } )
      .then( response => response.list )
      .then( response => {
        if (!response) return [];
        response = response.map( productData => {
          let product = new this.shop.ProductModel( productData )
          productStore.productById.set( product.map_id, product )
          return product
        } )
        return response
      } )
  }

  list( product_ids ) {
    if ( !Array.isArray( product_ids ) ) throw("list() expects an Array as its' sole argument")
    // /shop/rest/data/productlist?list=[100003,100004]
    // let url = this.config.API + `${baseSearchUrl}/productlist?list=${encodeURIComponent( JSON.stringify( product_ids ) )}` + app.getQueryLanguageParameter()
    if ( product_ids.length === 0 ) return Promise.resolve( [] )
    let url = this.config.API + `data/productlist?list=${encodeURIComponent( JSON.stringify( product_ids ) )}` + app.getQueryLanguageParameter()
    return $fetch( url, {
      mode       : 'cors',
      credentials: "include"
    } )
      .then( response => response.list )
      .then( response => {
        if ( !response ) return []
        response = response.map( productData => {
          let product = new this.shop.ProductModel( productData )
          productStore.productById.set( product.map_id, product )
          return product
        } )
        return response
      } )
  }

  /**
   * api.products.fromCategory(49) -> Get Products from category 49
   * @param value
   * @param sort
   * @param count
   * @param start
   * @returns {type[]}
   */
  fromCategory( value, { query = "", sort, page = 1, count = 6, dir } = {}, filters ) {
    //console.log('PRODUCTS: ',arguments,sort);
    let start = (page - 1) * count
    return this.query( {
      value : "",
      filter: filters ? [this.filters.category.query( value ), ...filters] : this.filters.category.query( value ),
      sort,
      count,
      start,
      dir
    } )
  }

  /**
   * [search description]
   * @param  {[type]} value  [description]
   * @param  {[type]} filter [description]
   * @param  {String} sort   [description]
   * @param  {Number} count  [description]
   * @param  {Number} start  [description]
   * @param dir
   * @return {[type]}                [description]
   */
  query( { value, filter, sort = "article_nr", count = 6, start = 0, dir } ) {

    if ( !value && !filter ) console.warn( "Invalid search term: ", value )
    // if ( value.length < 3 && value !== "%%" ) {
    //   return Promise.resolve( false )
    // }
    if ( !(sort in sort_options) ) {
      console.warn( "Unkown sort mode. Use", sort_options )
    }
    // '?filter=%5B%7B"cats"%3A%5B"83"%5D%7D%5D&start=0&count=6&sort=article_nr&dir=asc&?lang=de'
    let filterSegment = ""
    if ( filter ) {
      if ( !Array.isArray( filter ) ) filter = [filter]
      let f = JSON.stringify( filter )
      filterSegment = '&filter=' + encodeURIComponent( f )
    }

    let valueSegment = ""
    if ( value ) {
      valueSegment = 'value=' + value
    }

    let url = this.config.API + `${baseSearchUrl}/search?` + valueSegment + filterSegment + '&start=' + start + '&count=' + count + '&sort=' + sort + "&lang=" + app._currentLanguage
    if ( dir ) {
      url += `&dir=${dir}`
    }

    return $fetch( url, {
      mode       : 'cors',
      credentials: "include"
    } )
      .then( response => {
        response.products = response.result.map( productData => new this.shop.config.model.ProductModel( productData ) )
        return response
      } ).catch( ( err ) => {
        console.warn( "Failed search:", err )
        return {}
      } );

  }
}



// WEBPACK FOOTER //
// ./src/sdk/Products/Products.js